import React, { useEffect, useCallback, useState } from "react";
import { Table, Button, Checkbox, DatePicker, Tooltip, Space, Tag, row, Input, Select } from "antd";
import { DeleteOutlined, PlusOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import Big from "big.js";

import InputNumberField from "../../../../../components/Input/InputNumber";
import SearchListAutoComplete from "../../../../../components/SearchListAutoComplete";
import SharedFooter from "../../../../../components/DataTableFooter/SharedFooter";

import {
  addOrderRow,
  deleteOrderRow,
  updateOrderRow,
  setFooterValues,
  setPayPurchaseCart,
  calculateTotals,
} from "../purchaseSlice";

import {
  selectBatchAvailability,
  selectItems,
} from "../../../../../store/commonSelectors/lookupsSelectors";
import { selectAuthInfo } from "../../../../Auth/authSelectors";
import { fetchPendingPurchaseOrders } from "../purchaseThunk"; // ✅ thunk
import InputField from "../../../../../components/Input/Input";
import { fetchBatchAvailability, fetchItems } from "../../../../../store/commonThunks/lookups";
import { AutoComplete } from "antd";

import SearchAutoComplete from "../../../../../components/SearchAutoComplete";
import { fetchProductsList } from "../../../../Products/productsThunks";
import { selectGetProductsList } from "../../../../Products/productsSelectors";
import { useNavigate } from "react-router-dom";
import { getCurrencySymbol } from "../../../../../lib/currency";
import ProductQuickDrawer from "../../../../Product_manage/components/drawers/ProductQuickDrawer";
import SerialNumberModal from "./SerialNumberModal";
import { accessChecker } from "../../../../../lib/functions";
import { getItemDisplayName } from "../../../../../utils";

const PurchaseTable = () => {
  const dispatch = useDispatch();
  const items = useSelector(selectItems);
  const authInfo = useSelector(selectAuthInfo);
  const batchList = useSelector(selectBatchAvailability);
  const pendingPOs = useSelector((s) => s.purchaseEntry.pendingPOs);
  const footerValues = useSelector((s) => s.purchaseEntry.footerValues);
  const itemCart = useSelector((s) => s.purchaseEntry.itemCart);
  const taxMode = useSelector((s) => s.purchaseEntry.taxMode);
  const conversionRate = useSelector((s) => s.purchaseEntry.conversionRate);
  const conversionCurrency = useSelector((s) => s.purchaseEntry.conversion_currency);
  const supplier = useSelector((s) => s.purchaseEntry.supplierInfo);
  const navigate = useNavigate();
  const currency = authInfo?.currency || "AED";
  const isPO = useSelector((s) => s.purchaseEntry.isPO);
  const [productDrawer, setProductDrawer] = useState({ open: false, rowKey: null, });
  const [isAdminUser, isAdminUserSet] = useState(false);
  const isIndia = authInfo?.country?.toLowerCase() === "india";
  const taxLabel = isIndia ? "GST" : "VAT";
  const [serialModal, setSerialModal] =
    useState({
      open: false,
      row: null
    });

  const isTatmeen = useSelector((s) => s.purchaseEntry.isTatmeen);

  const showSerialColumn =
    authInfo?.is_tatmeen_enabled === "yes" &&
    authInfo?.country === "United Arab Emirates" && (authInfo?.subscription == 'PharmaERP_Pro' || authInfo?.subscription == 'PharmaERP_Standard' || authInfo?.subscription == 'PharmaERP_Basic');
  const hasTatmeenEntryAccess = accessChecker("tatmeen_entry");

  useEffect(() => {
    const hrRoles = [
      // Admin role
      "ForthERP_Basic_admin",
      "ForthERP_Standard_admin",
      "ForthERP_Pro_admin",
      "PharmaERP_Basic_admin",
      "PharmaERP_Standard_admin",
      "PharmaERP_Pro_admin",
      "PharmaBooks_Basic_admin",
      "PharmaBooks_Standard_admin",
      "PharmaBooks_Pro_admin",
      "ForthBooks_Basic_admin",
      "ForthBooks_Standard_admin",
      "ForthBooks_Pro_admin",
      "HRPayroll_Standard_admin",
      "HRPayroll_Pro_admin",
      "SuperERP_admin",
      "SuperERP_super_admin",
      "ForthCRM_Standard_admin",
      "ForthCRM_Pro_admin",
    ];

    console.log({
      is_tatmeen_enabled: authInfo?.is_tatmeen_enabled,
      country: authInfo?.country,
      condition:
        authInfo?.is_tatmeen_enabled === "yes" &&
        authInfo?.country === "United Arab Emirates",
    });

    // console.log("serialColumn", serialColumn);
    console.log("serialColumn1234", baseColumns);

    const userRoles = authInfo.userInfo.user_role_names
      ? authInfo.userInfo.user_role_names.split(",").map((role) => role.trim())
      : [];

    const isAdminHR = userRoles.some((role) => hrRoles.includes(role));

    isAdminUserSet(isAdminHR);
  }, [authInfo]);


  const symbol = getCurrencySymbol(
    conversionRate ? footerValues?.conversion_currency : currency
  );


  const fetchProducts = useCallback(
    (searchText) => {
      dispatch(
        fetchProductsList({
          query: searchText,
          search: true,
          partyType: "general",
        })
      );
    },
    [dispatch]
  );

  // ✅ when supplier changes, trigger thunk
  useEffect(() => {
    if (supplier?.acc_id) {
      dispatch(fetchPendingPurchaseOrders(supplier.acc_id));
    }
  }, [supplier, dispatch]);

  // merge items + pendingPOs for dropdown
  const mergedArray = [
    ...(pendingPOs || []).map((o) => ({
      ...o,
      type: "order",
      display_text: `PO-${o.pur_o_id} (${o.total_amount})`,
    })),
    ...(items || []).map((i) => ({
      ...i,
      type: "item",
      display_text: i.item_name,
    })),
  ];

  // const batchOptions = batches.map((b) => ({
  //   label: b.batch_name,
  //   value: b.id,
  //   obj: b,
  // }));

  // const handleUpdate = (rowKey, field, value) => {
  //   dispatch(updateOrderRow({ rowKey, updates: { [field]: value } }));
  //   dispatch(calculateTotals({ authInfo }));
  // };

  const gstEnabled = authInfo?.gst_enabled === "yes";
  const showTax = !isIndia || gstEnabled;

  const isGstDisabled =
    gstEnabled &&
    supplier?.gst_type === "unregistered";

  const handleUpdate = (rowKey, field, value) => {
    const row = itemCart.find((r) => r.key === rowKey);
    const updates = { [field]: value };

    if (["quantity", "rate", "discount", "discountAmt", "discountMode", "tax_per", "bonus"].includes(field)) {
      const qty = Number(field === "quantity" ? value : row.quantity) || 0;
      const rate = Number(field === "rate" ? value : row.rate) || 0;
      const tax_per = isGstDisabled
        ? 0
        : Number(field === "tax_per" ? value : row.tax_per) || 0;
      const discountMode =
        (field === "discountMode" ? value : row.discountMode) === "amount"
          ? "amount"
          : "percent";
      const discount = Number(field === "discount" ? value : row.discount) || 0;
      const discountAmtInput =
        Number(field === "discountAmt" ? value : row.discountAmt) || 0;

      let line = new Big(qty).times(rate);
      if (taxMode === "individual") {
        let discountAmt;
        if (discountMode === "amount") {
          const raw = new Big(discountAmtInput);
          discountAmt = raw.gt(line) ? line : raw.lt(0) ? new Big(0) : raw;
        } else {
          discountAmt = line.times(discount).div(100);
        }
        line = line.minus(discountAmt);

        const taxAmt = line.times(tax_per).div(100);
        line = line.plus(taxAmt);
      }

      updates.line_total = (
        conversionRate
          ? line.times(conversionRate)
          : line
      ).toFixed(2);
    }

    dispatch(updateOrderRow({ rowKey, updates }));
    dispatch(calculateTotals({ authInfo }));
  };

  const handleAddRow = () => {
    const newRow = {
      key: Date.now(),
      item_id: null,
      product: "",
      quantity: null,
      rate: null,
      tax_per: 0,
      discount: null,
      discountAmt: null,
      discountMode: "percent",
      bonus: false,

      batch_name: "",
      batch_id: 0,
      batch_expiry: null,

      child_sscc_code: "",

      is_expiry_disable: false,
      gtn_num: "",
      serials: [],
      is_serial: "no",
      serial_mode: "unit",
      is_tatmeen_required: false,
    };
    dispatch(addOrderRow(newRow));
  };

  const handleFooterChange = (value, field) => {
    let updatedFooter = { ...footerValues };

    if (field === "payServiceCart") {
      const totalServiceCharge = Array.isArray(value)
        ? value.reduce((sum, item) => sum.plus(item?.tran_amount || 0), new Big(0)).toNumber()
        : 0;

      updatedFooter = {
        ...updatedFooter,
        payServiceCart: value,
        other_service_cost: totalServiceCharge,
        // grandTotal: (
        //   parseFloat(updatedFooter.grandTotal || 0) + totalServiceCharge
        // ).toFixed(2),
      };

      dispatch(setFooterValues(updatedFooter));
      dispatch(calculateTotals({ authInfo }));
      return;
    }

    if (field === "payCart") {
      const newPaidAmount = value
        .filter((item) => item.acc_type_id !== "cheque") // 👈 exclude cheques
        .reduce((sum, item) => sum + parseFloat(item.tran_amount || 0), 0);

      updatedFooter = {
        ...updatedFooter,
        paidAmount: newPaidAmount,
        dueAmount: (
          parseFloat(updatedFooter.grandTotal || 0) - newPaidAmount
        ).toFixed(2),
      };
      dispatch(setPayPurchaseCart(value));
    } else {
      updatedFooter[field] = value;
    }
    dispatch(setFooterValues(updatedFooter));
    dispatch(calculateTotals({ authInfo }));
  };

  const getFilteredItemsForRow = (record) => {
    return items.filter((it) => {
      return !itemCart.some((row) => {
        if (row.key === record.key) return false;
        return row.item_id === it.item_id;
      });
    });
  };

  // creating batch name cell here to use in column below
  // const BatchNameCell = ({ record }) => {
  //   const batches = useSelector((s) =>
  //     selectBatchAvailability(s, record.item_id)
  //   );

  //   // ✅ Match item dropdown option structure
  //   const options = (batches || []).map((b) => ({
  //     label: b.batch_name,
  //     value: b.batch_name,
  //     id: b.id,
  //     obj: b
  //   }));
  //   return (
  //     // <SearchListAutoComplete
  //     //   placeholder="or Enter Batch"
  //     //   style={{ width: "100%" }}
  //     //   optionsList={options}
  //     //   value={
  //     //     record.batch_name
  //     //       ? { value: record.batch_name, label: record.batch_name }
  //     //       : undefined
  //     //   }
  //     //   onSelect={(obj) => {
  //     //     const batch = obj?.raw;
  //     //     if (batch) {
  //     //       handleUpdate(record.key, "batch_name", batch.batch_name);
  //     //       handleUpdate(record.key, "batch_id", batch.id);
  //     //       handleUpdate(record.key, "batch_expiry", batch.batch_expiry);
  //     //       handleUpdate(record.key, "is_expiry_disable", true);
  //     //     } else {
  //     //       handleUpdate(record.key, "batch_name", obj?.value || "");
  //     //       handleUpdate(record.key, "batch_id", 0);
  //     //       handleUpdate(record.key, "batch_expiry", null);
  //     //       handleUpdate(record.key, "is_expiry_disable", false);
  //     //     }
  //     //   }}
  //     //   onChange={(val) => {
  //     //     if (typeof val === "string") {
  //     //       handleUpdate(record.key, "batch_name", val);
  //     //       handleUpdate(record.key, "batch_id", 0);
  //     //       handleUpdate(record.key, "is_expiry_disable", false);
  //     //     } else if (val?.value) {
  //     //       handleUpdate(record.key, "batch_name", val.value);
  //     //       handleUpdate(record.key, "batch_id", 0);
  //     //       handleUpdate(record.key, "is_expiry_disable", false);
  //     //     }
  //     //   }}
  //     //   showAddNew={false}
  //     //   allowClear
  //     // />
  //     <AutoComplete
  //       style={{ width: 200 }}
  //       options={options}
  //       placeholder="Select/Enter Batch"
  //       filterOption={(inputValue, option) =>
  //         String(option.value)
  //           .toUpperCase()
  //           .includes(inputValue.toUpperCase())
  //       }
  //       onSelect={(value, option) => {
  //         // selected existing batch
  //     
  //         if (option?.id) {
  //           handleUpdate(record.key, "batch_name", option.value);
  //           handleUpdate(record.key, "batch_id", option.id);
  //           handleUpdate(record.key, "batch_expiry", option.obj.batch_expiry || null);
  //           handleUpdate(record.key, "is_expiry_disable", true);
  //         }
  //       }}
  //       onChange={(value) => {
  //         // typed batch name (may not exist)
  //         const found = (batches || []).find((b) => b.batch_name === value);
  //         if (found) {
  //           // user typed an exact match for existing batch
  //           handleUpdate(record.key, "batch_name", found.batch_name);
  //           handleUpdate(record.key, "batch_id", found.id);
  //           handleUpdate(record.key, "batch_expiry", found.batch_expiry || null);
  //           handleUpdate(record.key, "is_expiry_disable", true);
  //         } else {
  //           // new batch name
  //           handleUpdate(record.key, "batch_name", value);
  //           handleUpdate(record.key, "batch_id", 0);
  //           handleUpdate(record.key, "batch_expiry", null);
  //           handleUpdate(record.key, "is_expiry_disable", false);
  //         }
  //       }}
  //     />
  //   );
  // };


  const BatchNameCell = ({ record }) => {
    const batches = useSelector((s) =>
      selectBatchAvailability(s, record.item_id)
    );

    const options = (batches || [])
      .filter((b) => b.serial_mode != "batch")
      .map((b) => ({
        label: b.batch_name,
        value: b.batch_name,
        id: b.id,
        obj: b,
      }));

    // local state for typing
    const [inputValue, setInputValue] = React.useState(record.batch_name || "");

    // update local state if Redux record changes (e.g., after selection elsewhere)
    React.useEffect(() => {
      setInputValue(record.batch_name || "");
    }, [record.batch_name]);

    return (
      <AutoComplete
        style={{ width: "100%", minWidth: 120 }}
        options={options}
        placeholder="Select/Enter Batch"
        value={inputValue}
        filterOption={(inputValue, option) =>
          String(option.value).toUpperCase().includes(inputValue.toUpperCase())
        }
        onSelect={(value, option) => {
          setInputValue(option.value);
          handleUpdate(record.key, "batch_name", option.value);
          handleUpdate(record.key, "batch_id", option.id || 0);
          handleUpdate(
            record.key,
            "batch_expiry",
            option.obj?.batch_expiry || null
          );
          handleUpdate(record.key, "is_expiry_disable", !!option.id);
        }}
        onChange={(value) => {
          setInputValue(value); // update local input while typing
        }}
        onBlur={() => {
          // on blur, sync with Redux
          const found = (batches || []).find(
            (b) => b.batch_name === inputValue && b.serial_mode !== "batch"
          );
          if (found) {
            handleUpdate(record.key, "batch_name", found.batch_name);
            handleUpdate(record.key, "batch_id", found.id);
            handleUpdate(
              record.key,
              "batch_expiry",
              found.batch_expiry || null
            );
            handleUpdate(record.key, "is_expiry_disable", true);
          } else {
            handleUpdate(record.key, "batch_name", inputValue);
            handleUpdate(record.key, "batch_id", 0);
            handleUpdate(record.key, "batch_expiry", null);
            handleUpdate(record.key, "is_expiry_disable", false);
          }
        }}
        allowClear
      />
    );
  };
  const baseColumns = [
    {
      title: "Bonus",
      dataIndex: "bonus",
      render: (_, record) => (
        <Checkbox
          checked={record.bonus}
          onChange={(e) => handleUpdate(record.key, "bonus", e.target.checked)}
        />
      ),
    },
    ...(hasTatmeenEntryAccess && showSerialColumn
      ? [
        {
          title: "Tatmeen",
          dataIndex: "is_tatmeen_required",
          width: 100,
          render: (_, record) => (
            <Checkbox
              checked={record.is_tatmeen_required || false}
              disabled={!isTatmeen || isPO}
              onChange={(e) => {
                const checked = e.target.checked;
                handleUpdate(record.key, "is_tatmeen_required", checked);

                // If unchecked, clear SSCC and serials
                if (!checked) {
                  handleUpdate(record.key, "child_sscc_code", "");
                  handleUpdate(record.key, "serials", []);
                  handleUpdate(record.key, "serial_mode", "unit");
                } else {
                  handleUpdate(record.key, "serial_mode", "unit");
                  // Initialize serials array based on quantity
                  const quantity = Number(record.quantity) || 0;
                  const serials = Array(quantity).fill('');
                  handleUpdate(record.key, "serials", serials);
                }
              }}
            >
              Required
            </Checkbox>
          ),
        }
      ]
      : []),
    {
      title: "Search Item",
      dataIndex: "product",
      width: 200,
      // render: (_, record) => (
      //   <SearchListAutoComplete
      //     placeholder="Item"
      //     style={{ width: "100%" }}
      //     optionsList={(items || []).map((i) => ({
      //       sale_id: i.item_id,
      //       display_text: i.item_name,
      //       label: i.item_name,
      //       raw: i,
      //     }))}
      //     value={
      //       record.item_id
      //         ? { value: record.product, label: record.product }
      //         : undefined
      //     }
      //       }
      //     onSelect={(obj) => {
      //       const it = obj?.raw;
      //       if (!it) return;

      //       handleUpdate(record.key, "item_id", it.item_id);
      //       handleUpdate(record.key, "product", it.item_name);
      //       handleUpdate(record.key, "rate", it.purchase_rate ?? 0);
      //       handleUpdate(record.key, "tax_per", it.tax_per ?? 0);
      //       handleUpdate(record.key, "unit_id", it.unit_id ?? 0);
      //       handleUpdate(record.key, "unit_name", it.unit_name || "");
      //       handleUpdate(record.key, "unit_symbol", it.unit_symbol || "");
      //       handleUpdate(record.key, "units", it.units || []);

      //       handleUpdate(record.key, "batch_name", "");
      //       handleUpdate(record.key, "batch_id", 0);
      //       handleUpdate(record.key, "batch_expiry", null);
      //       handleUpdate(record.key, "is_expiry_disable", false);

      //       dispatch(fetchBatchAvailability(it.item_id));
      //     }}
      //   />
      // ),

      render: (_, record) => (
        <SearchAutoComplete
          style={{ width: "100%", minWidth: 180 }}
          searchThunk={(text) => fetchProducts(text)}
          resultSelector={selectGetProductsList}
          filterResult={(results) =>
            results
              .filter((r) => r.is_service !== 'yes') // ✅ REMOVE SERVICES
              .filter(
                (r) =>

                  !itemCart.some(
                    (row) => row.key !== record.key && row.item_id === r.item_id
                  )
              )
          }
          value={
            record.item_id
              ? {
                item_id: record.item_id,
                item_name: record.product,
                // `product` is also what gets saved as this row's item_name
                // (see utils/purchaseEntry.js), so it stays the plain name --
                // the fuller "name - code - barcode" label only lives in
                // product_display, used for showing/picking in this field.
                display_text: record.product_display || record.product,
              }
              : null
          }
          allowClear
          onSelect={async (value) => {
            if (!value || value === null) {
              // 🔑 CLEAR CASE
              handleUpdate(record.key, "item_id", null);
              handleUpdate(record.key, "is_asset", false);
              handleUpdate(record.key, "product", "");
              handleUpdate(record.key, "product_display", "");
              handleUpdate(record.key, "rate", 0);
              handleUpdate(record.key, "tax_per", 0);
              handleUpdate(record.key, "quantity", null);
              handleUpdate(record.key, "batch_name", "");
              handleUpdate(record.key, "batch_id", 0);
              handleUpdate(record.key, "batch_expiry", null);
              handleUpdate(record.key, "is_expiry_disable", false);
              handleUpdate(record.key, "gtn_num", "");
              handleUpdate(record.key, "is_tatmeen_required", false);
              handleUpdate(record.key, "child_sscc_code", "");
              handleUpdate(record.key, "serials", []);
              handleUpdate(record.key, "serial_mode", "unit");
              return;
            }
            if (value === "add_new") {
              setProductDrawer({
                open: true,
                rowKey: record.key,
              });
              return;
            }

            handleUpdate(record.key, "item_id", value.item_id);
            handleUpdate(record.key, "is_asset", value.is_asset === "yes");
            handleUpdate(record.key, "product", value.item_name);
            handleUpdate(record.key, "product_display", value.display_text || value.item_name);
            handleUpdate(record.key, "rate", value.purchase_rate ?? 0);
            handleUpdate(record.key, "tax_per", value.tax_per ?? 0);
            handleUpdate(record.key, "unit_id", value.unit_id ?? 0);
            handleUpdate(record.key, "unit_name", value.unit_name || "");
            handleUpdate(record.key, "unit_symbol", value.unit_symbol || "");
            handleUpdate(record.key, "units", value.units || []);

            handleUpdate(record.key, "batch_name", "");
            handleUpdate(record.key, "batch_id", 0);
            handleUpdate(record.key, "batch_expiry", null);
            handleUpdate(record.key, "is_expiry_disable", false);
            handleUpdate(record.key, "gtn_num", value.gtn_num || "");

            handleUpdate(record.key, "is_serial", "yes" || "no");
            handleUpdate(record.key, "serial_mode", "unit");
            handleUpdate(record.key, "is_tatmeen_required", false);
            handleUpdate(record.key, "child_sscc_code", "");
            handleUpdate(record.key, "serials", []);
            dispatch(fetchBatchAvailability({ item_id: value.item_id }));
          }}
          placeholder={"products"}
          disabled={isPO}
        />
      ),
    },

    ...(authInfo?.enable_batch_number !== "no"
      ? [
        {
          title: "Batch Number",
          dataIndex: "batch_name",
          render: (_, record) => {
            return <BatchNameCell record={record} />;
          }
        },
        {
          title: "Batch Expiry",
          dataIndex: "batch_expiry",
          width: 200,
          render: (_, record) => (
            <DatePicker
              style={{ width: "100%" }}
              value={record.batch_expiry ? dayjs(record.batch_expiry) : null}
              onChange={(d) =>
                handleUpdate(
                  record.key,
                  "batch_expiry",
                  d ? d.format("YYYY-MM-DD") : null
                )
              }
              disabled={record.is_expiry_disable}
            />
          ),
        },
      ]
      : []),
    {
      title: "Quantity",
      dataIndex: "quantity",
      width: 120,
      render: (_, record) => (
        <InputNumberField
          precision={1}
          step={0.5}
          value={record.quantity}
          onClick={() => {
            if (record.quantity !== null) {
              handleUpdate(record.key, "quantity", null);
            }
          }}
          onChange={(v) => handleUpdate(record.key, "quantity", v)}
        />
      ),
    },
    {
      title: "Rate",
      dataIndex: "rate",
      width: 100,
      render: (_, record) => (
        <InputNumberField
          min={0}
          step={1}
          precision={2}
          value={
            record.bonus
              ? 0
              :
              conversionRate ? new Big(record?.rate || 0).times(conversionRate).toNumber() : record?.rate
          }
          placeholder="0.00"
          onClick={() => {
            if (!record.bonus && record.rate !== null) {
              handleUpdate(record.key, "rate", null);
            }
          }}
          onChange={(v) => handleUpdate(record.key, "rate", v)}
          // onBlur={(e) => {
          //   const val = parseFloat(e.target.value || 0).toFixed(2);
          //   handleUpdate(record.key, "rate", Number(val));
          // }}
          formatter={
            (val) =>
              `${currency} ${val}`
                ?.replace(/[^0-9.]/g, "") // Allow only numbers & dot
                .replace(/^0+/, "0") // Prevent multiple leading zeros
                .replace(/(\.\d{2})\d+/, "$1") // Limit to 2 decimal places
          }

        />
      ),
    },

  ];

  const individualColumns = [
    {
      title: "Discount",
      dataIndex: "discount",
      width: 160,
      render: (_, record) => {
        const discountMode = record.discountMode === "amount" ? "amount" : "percent";
        const lineTotal = (Number(record.quantity) || 0) * (Number(record.rate) || 0);
        // One merged compound field (number input + unit-select addon)
        // instead of a separate Select stacked above the number input.
        const modeSelect = (
          <Select
            size="small"
            style={{ width: 65 }}
            disabled={record.bonus}
            value={discountMode}
            options={[
              { label: "%", value: "percent" },
              { label: symbol, value: "amount" },
            ]}
            onChange={(v) => handleUpdate(record.key, "discountMode", v)}
          />
        );
        return discountMode === "amount" ? (
          <InputNumberField
            min={0}
            max={lineTotal}
            disabled={record.bonus}
            value={record.bonus ? 0 : record.discountAmt}
            placeholder="0"
            onChange={(v) => handleUpdate(record.key, "discountAmt", v)}
            addonAfter={modeSelect}
          />
        ) : (
          <InputNumberField
            min={0}
            max={100}
            disabled={record.bonus}
            value={record.bonus ? 0 : record.discount}
            placeholder="0"
            onClick={() => {
              if (!record.bonus && record.discount !== null) {
                handleUpdate(record.key, "discount", null);
              }
            }}
            onChange={(v) => handleUpdate(record.key, "discount", v)}
            addonAfter={modeSelect}
          />
        );
      },
    },
  ];

  const gstColumn = showTax
    ? [
      {
        title: `${taxLabel} %`,
        dataIndex: "tax_per",
        width: 100,
        render: (_, record) => (
          <InputNumberField
            min={0}

            value={record.bonus ? 0 : (isGstDisabled ? 0 : record.tax_per)}
            onChange={(v) => handleUpdate(record.key, "tax_per", v)}
            disabled={record.bonus || isGstDisabled}
          />
        ),
      },
    ]
    : [];

  const amountColumn = [
    {
      title: "Line Total",
      render: (_, r) => {
        if (r.bonus) return "0.00";
        const qty = new Big(r.quantity || 0);
        const rate = new Big(r.rate || 0);
        let line = qty.times(rate);
        if (taxMode === "individual") {
          const discountMode = r.discountMode === "amount" ? "amount" : "percent";
          let discountAmt;
          if (discountMode === "amount") {
            const raw = new Big(r.discountAmt || 0);
            discountAmt = raw.gt(line) ? line : raw.lt(0) ? new Big(0) : raw;
          } else {
            const discountPct = new Big(r.discount || 0);
            discountAmt = line.times(discountPct).div(100);
          }
          const afterDiscount = line.minus(discountAmt);
          const taxPct = (!showTax || isGstDisabled)
            ? new Big(0)
            : new Big(r.tax_per || 0);
          const taxAmt = afterDiscount.times(taxPct).div(100);
          line = afterDiscount.plus(taxAmt);
        }

        const convertedLine = conversionRate
          ? line.times(conversionRate)
          : line;
        //  handleUpdate(r.key, "item_total",convertedLine)
        // dispatch(
        //   updateOrderRow({
        //     rowKey: r.key,
        //     updates: { line_total: convertedLine },
        //   })
        // );
        return convertedLine.toFixed(2);
      },
    },
    ...(isAdminUser
      ? [
        {
          title: "",
          align: "center",
          render: (_, r) => (
            <Button
              icon={<DeleteOutlined />}
              danger
              onClick={() => dispatch(deleteOrderRow(r.key))}
              disabled={itemCart.length === 1}
            />
          ),
        },
      ]
      : []),
  ];

  // const serialModeColumn = showSerialColumn ? [
  //   {
  //     title: (
  //       <Tooltip title="Enable serial tracking for this item">
  //         <span>
  //           Serial Mode <InfoCircleOutlined style={{ fontSize: 12, color: '#1890ff' }} />
  //         </span>
  //       </Tooltip>
  //     ),
  //     dataIndex: "serial_mode",
  //     width: 100,
  //     render: (_, record) => {
  //       // Default to 'quantity' mode
  //       const isBatchMode = record.serial_mode === 'batch';

  //       return (
  //         <Checkbox
  //           checked={isBatchMode}
  //           onChange={(e) => {
  //             if (e.target.checked) {
  //               // Switch to batch mode - only 1 serial needed
  //               handleUpdate(record.key, 'serial_mode', 'batch');
  //               // Initialize with empty serial array for batch
  //               handleUpdate(record.key, 'serials', []);
  //             } else {
  //               // Switch back to quantity mode
  //               handleUpdate(record.key, 'serial_mode', 'quantity');
  //               // Reset serials based on quantity
  //               const quantity = Number(record.quantity) || 0;
  //               const serials = Array(quantity).fill('');
  //               handleUpdate(record.key, 'serials', serials);
  //             }
  //           }}
  //         >
  //           Per Batch
  //         </Checkbox>
  //       );
  //     },
  //   },
  // ] : [];

  const serialActionColumn = showSerialColumn && hasTatmeenEntryAccess
    ? [
      {
        title: "Child SSCC",
        dataIndex: "child_sscc_code",
        width: 320,
        render: (_, record) => (
          <Input
            value={record.child_sscc_code || ""}
            style={{ minWidth: "100px" }}
            placeholder={record.is_tatmeen_required ? "Required*" : "Optional"}
            disabled={!record.is_tatmeen_required || !isTatmeen || isPO}
            onChange={(e) =>
              handleUpdate(
                record.key,
                "child_sscc_code",
                e.target.value
              )
            }
          />
        )
      },
      {
        title: "SERIAL MODE",
        dataIndex: "serial_mode",
        render: (_, record) => (
          <Checkbox
            checked={record.serial_mode === "batch"}
            disabled={!record.is_tatmeen_required || !isTatmeen || isPO}
            onChange={(e) =>
              handleUpdate(
                record.key,
                "serial_mode",
                e.target.checked ? "batch" : "unit"
              )
            }
          >
            Per Batch
          </Checkbox>
        ),
      },
      {
        title: "Serials",
        width: 160,
        render: (_, record) => {
          // If Tatmeen not required, show "Not Required"
          if (!record.is_tatmeen_required) {
            return <Tag color="default">Not Required</Tag>;
          }

          const serials = record.serials || [];
          const totalSerials = serials.filter(s => s && s.trim()).length;
          const isBatchMode = record.serial_mode === 'batch';
          const requiredSerials = isBatchMode ? 1 : Number(record.quantity) || 0;
          const isComplete = totalSerials === requiredSerials && requiredSerials > 0;
          const hasPartial = totalSerials > 0 && totalSerials < requiredSerials;

          let statusColor = 'default';
          let statusText = '';

          if (isComplete) {
            statusText = `${totalSerials}/${requiredSerials} ✓`;
            statusColor = 'success';
          } else if (hasPartial) {
            statusText = `${totalSerials}/${requiredSerials}`;
            statusColor = 'warning';
          } else {
            statusText = `0/${requiredSerials}`;
            statusColor = 'error';
          }

          return (
            <Space>
              <Button
                size="small"
                type={isComplete ? "primary" : "default"}
                disabled={!record.is_tatmeen_required}
                onClick={() =>
                  setSerialModal({
                    open: true,
                    row: record,
                  })
                }
              >
                {record.serial_mode === "batch"
                  ? `Batch Serial (${totalSerials}/1)`
                  : `Serials (${totalSerials}/${requiredSerials})`}
              </Button>
              <Tag color={statusColor} style={{ minWidth: 50, textAlign: 'center' }}>
                {statusText}
              </Tag>
            </Space>
          );
        },
      },
    ] : [];

  const columns =
    taxMode === "individual"
      ? [...baseColumns, ...serialActionColumn, ...individualColumns, ...gstColumn, ...amountColumn]
      : [...baseColumns, ...serialActionColumn, ...amountColumn];

  return (
    <div>
      <Button
        type="dashed"
        onClick={handleAddRow}
        icon={<PlusOutlined />}
        style={{ marginBottom: 8 }}
      >
        Add Row
      </Button>
      <div style={{ width: "100%", maxWidth: "1300px" }}>
        <Table
          dataSource={itemCart}
          columns={columns}
          pagination={false}
          rowKey="key"
          scroll={{ x: "max-content" }}
          footer={() => (
            <SharedFooter
              footerValues={footerValues}
              dataSource={itemCart}
              onFooterChange={handleFooterChange}
              pageType="purchaseEntry"
              taxMode={taxMode}
              conversionRate={conversionRate}
              conversionCurrency={conversionCurrency}
            />
          )}
        />
      </div>

      <ProductQuickDrawer
        open={productDrawer.open}
        onClose={() => setProductDrawer({ open: false, rowKey: null })}
        onCreated={(product) => {
          if (!product) return;

          // 1️⃣ Close drawer first
          setProductDrawer({ open: false, rowKey: null });

          // 2️⃣ Refresh product autocomplete source
          dispatch(
            fetchProductsList({
              query: product.item_name,
              search: true,
              partyType: "general",
            })
          );

          // 3️⃣ Update row directly using created product
          handleUpdate(productDrawer.rowKey, "item_id", product.item_id);
          handleUpdate(productDrawer.rowKey, "product", product.item_name);
          handleUpdate(productDrawer.rowKey, "product_display", getItemDisplayName(product));
          handleUpdate(productDrawer.rowKey, "rate", product.purchase_rate ?? 0);
          handleUpdate(productDrawer.rowKey, "tax_per", product.tax_per ?? 0);
          handleUpdate(productDrawer.rowKey, "unit_id", product.unit_id ?? 0);
          handleUpdate(productDrawer.rowKey, "unit_name", product.unit_name || "");
          handleUpdate(productDrawer.rowKey, "unit_symbol", product.unit_symbol || "");
          handleUpdate(productDrawer.rowKey, "units", product.units || []);

          handleUpdate(productDrawer.rowKey, "batch_name", "");
          handleUpdate(productDrawer.rowKey, "batch_id", 0);
          handleUpdate(productDrawer.rowKey, "batch_expiry", null);
          handleUpdate(productDrawer.rowKey, "is_expiry_disable", false);
          handleUpdate(productDrawer.rowKey, "gtn_num", product.gtn_num || "");
          dispatch(fetchBatchAvailability({ item_id: product.item_id }));
        }}
      />
      <SerialNumberModal
        open={serialModal.open}
        row={serialModal.row}
        onCancel={() =>
          setSerialModal({
            open: false,
            row: null
          })
        }
        onSave={(serials) => {
          console.log("Saved Serials:", serials);

          dispatch(
            updateOrderRow({
              rowKey: serialModal.row.key,
              updates: { serials }
            })
          );
        }}

      />
    </div>

  );
};

export default PurchaseTable;
